// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"f20ff387","714":"1cb085b4"}[chunkId] + ".chunk.js";
};